// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hMeqJ","title":"styles_title__cpUrz","row":"styles_row__Of9N2","valueTitle":"styles_valueTitle__bg70O","hiddenTitle":"styles_hiddenTitle__-wltD"};